import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { useHouseDispatch, useHouseState } from "../../contexts/HouseContext";
import "./LedgerModal.css";

export const AddPlayerModal = ({ gameId, players, show, handleClose }) => {
    const [mode, setMode] = useState("editPlayers");
    const isPlayerMode = mode === "editPlayers";

    const toggleMode = () =>
        setMode(isPlayerMode ? "addMember" : "editPlayers");

    const onMemberAdded = () => setMode("editPlayers");

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            dialogClassName="lm-dialog"
            backdropClassName="lm-backdrop"
            centered
        >
            <div className="lm-head">
                <div className="lm-head-l">
                    <div className="lm-kicker">
                        {isPlayerMode ? "Roster" : "New member"}
                    </div>
                    <h2 className="lm-title">
                        {isPlayerMode ? (
                            <>
                                Pick <em>players</em> for this game
                            </>
                        ) : (
                            <>
                                Add a <em>member</em>
                            </>
                        )}
                    </h2>
                </div>
                <button
                    type="button"
                    className="lm-close"
                    aria-label="Close"
                    onClick={handleClose}
                >
                    ×
                </button>
            </div>

            <div className="lm-body">
                {isPlayerMode ? (
                    <EditPlayersForm players={players} gameId={gameId} />
                ) : (
                    <AddMemberForm gameId={gameId} onSubmitted={onMemberAdded} />
                )}
            </div>

            <div className="lm-foot">
                <span className="lm-foot-meta">
                    {isPlayerMode
                        ? "Toggle to add or remove from this game"
                        : "New member is auto-added to this game"}
                </span>
                <div className="lm-foot-actions">
                    <button
                        type="button"
                        className="lm-cancel"
                        onClick={toggleMode}
                    >
                        {isPlayerMode ? "Add new member" : "Cancel"}
                    </button>
                    {isPlayerMode && (
                        <button
                            type="button"
                            className="lm-submit"
                            onClick={handleClose}
                        >
                            Done
                        </button>
                    )}
                </div>
            </div>
        </Modal>
    );
};

const EditPlayersForm = ({ gameId, players }) => {
    const { addPlayer, removePlayer } = useHouseDispatch();
    const { house } = useHouseState();

    const handleToggle = (member, isMemberPlayer, playerId) => async (e) => {
        e.stopPropagation();
        if (isMemberPlayer) {
            await removePlayer(gameId, playerId);
        } else {
            await addPlayer(gameId, member.id);
        }
    };

    return (
        <div className="lm-member-list">
            {house.members.map((m) => {
                const player = players.find((p) => p.memberId === m.id);
                const isMemberPlayer = player !== undefined;
                const playerId = player?.id ?? m.id;
                const isDisabled = isMemberPlayer && (player.transactions?.length ?? 0) > 0;

                return (
                    <div
                        key={m.id}
                        className={`lm-member-row${isDisabled ? " is-disabled" : ""}`}
                        onClick={
                            isDisabled
                                ? undefined
                                : handleToggle(m, isMemberPlayer, playerId)
                        }
                    >
                        <div>
                            <div className="lm-member-name">{m.name}</div>
                            {isDisabled && (
                                <span className="lm-member-meta">
                                    Has transactions · can't remove
                                </span>
                            )}
                        </div>
                        <span
                            className={`lm-toggle${isMemberPlayer ? " is-on" : ""}`}
                            aria-hidden="true"
                        />
                    </div>
                );
            })}
        </div>
    );
};

const AddMemberForm = ({ gameId, onSubmitted }) => {
    const { addMember, addPlayer } = useHouseDispatch();
    const [error, setError] = useState(null);

    const onSubmit = async (e) => {
        e.preventDefault();
        const name = e.target.elements.name.value.trim();
        if (!name) return;
        try {
            const newMember = await addMember(name);
            await addPlayer(gameId, newMember.id);
            onSubmitted();
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <form onSubmit={onSubmit}>
            <span className="lm-l">Member name</span>
            <label className="amt-input-wrap" style={{ padding: "12px 16px" }}>
                <input
                    type="text"
                    name="name"
                    className="amt-input"
                    placeholder="e.g. Charlie"
                    autoFocus
                    style={{ fontSize: 18 }}
                    required
                />
            </label>
            {error && <div className="lm-error">{error}</div>}
            <div style={{ marginTop: 14, display: "flex", justifyContent: "flex-end" }}>
                <button type="submit" className="lm-submit">
                    Add member
                </button>
            </div>
        </form>
    );
};
